import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsSchemaLayoutContextInterface } from '../schema/layout-context.interface';
import { PageTypeType } from '../types';

export class Snowplow2StatsAdapterSchemaLayoutContext implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaLayoutContextInterface {
    const schema: Snowplow2StatsSchemaLayoutContextInterface = {
      schema: 'iglu:ae.propertyfinder/layout_context/jsonschema/1-0-1',
      data: {
        layout_version: '1',
        page_type: this.getPageType(),
        block: this.getBlock(),
      },
    };

    return schema;
  }

  /**
   * Returns the page type value according to the global context
   */
  protected getPageType(): PageTypeType {
    if (this.context.global.home_page) {
      return 'portal_home';
    }

    if (this.context.global.property_serp) {
      return 'property_serp';
    }

    if (this.context.global.property_page) {
      return 'property_detail';
    }

    if (this.context.global.property_page_offline) {
      return 'expired_property';
    }

    if (this.context.global.agent_page) {
      return 'agent_detail';
    }

    if (this.context.global.agent_serp) {
      return 'agent_serp';
    }

    if (this.context.global.agent_home) {
      return 'agent_home';
    }

    if (this.context.global.broker_page) {
      return 'broker_detail';
    }

    if (this.context.global.broker_serp) {
      return 'broker_serp';
    }

    if (this.context.global.broker_home) {
      return 'broker_home';
    }

    if (this.context.global.contacted_properties || this.context.global.saved_properties) {
      return 'my_account';
    }

    if (this.context.global.buyvsrent_calculator) {
      return 'buyvsrent_calculator';
    }

    if (this.context.global.project_detail) {
      return 'project_detail';
    }

    // TODO-FE[later] missing: building_review detail, not_found

    return 'static';
  }

  /**
   * Returns the page type value according to the local context
   */
  protected getBlock(): string {
    if (this.context.local.property_more) {
      return 'property_more';
    }

    if (this.context.local.property_similar) {
      return 'property_similar';
    }

    if (this.context.global.saved_properties) {
      return 'saved_properties';
    }

    if (this.context.global.contacted_properties) {
      return 'contacted_properties';
    }

    return '';
  }
}
